import React, { useEffect, useState } from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { FormProvider, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { FormRow } from '@gravity-ui/components';
import { Button, Link, TextInput } from '@gravity-ui/uikit';
import { zodResolver } from '@hookform/resolvers/zod';

import { useUserPassRecoveryMutation } from 'store/api';

import { InfoMessage } from '../../utils';
import {
	ADMINISTRATOR,
	EMAIL,
	EMAIL_RECOVERY,
	PASSWORD_PROBLEM,
	PASSWORD_RECOVERY,
	RECOVERY_LINK,
	SEND_LINK_RECOVERY,
} from '../constants';
import type { PassRecovery } from '../utils';
import { useValidationRec } from '../utils';

import styles from './styles.module.scss';

export const LoginPassRecovery = () => {
	const [showMessage, setShowMessage] = useState(false);
	const [isFetching, setIsFetching] = useState(true);

	const { passRecoverySchema: schema } = useValidationRec();

	const methods = useForm<PassRecovery>({
		resolver: zodResolver(schema),
		defaultValues: { email: '' },
	});

	const [userPassRecovery, { isLoading, isError, error, isSuccess }] = useUserPassRecoveryMutation();

	const {
		watch,
		register,
		handleSubmit,
		formState: { errors },
	} = methods;

	const formValues = watch();

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsFetching(isLoading);
		}, 800);

		if (isSuccess) {
			toast.success('Успешно!');
			setShowMessage(true);
		}
		if (isError) {
			toast.error((error as any).data.message, {
				position: 'top-right',
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	const onSubmitHandler: SubmitHandler<PassRecovery> = (value) => {
		userPassRecovery(value);
	};

	return (
		<>
			{/*{isFetching && <Loader size="l" className={styles.loader} />} TODO настроить на 300 мл сек, отображается если больше, переместить */}
			{!isLoading && !showMessage && (
				<div className={styles.login_recovery}>
					<>
						<h1>{PASSWORD_RECOVERY}</h1>

						<div className={styles.login_recovery__text}>{RECOVERY_LINK}</div>

						<FormProvider {...methods}>
							<form className={styles.login_recovery__form}>
								<div className={styles.login_recovery__form__group}>
									<FormRow label={EMAIL_RECOVERY} direction="column">
										<TextInput
											size="xl"
											{...register('email')}
											error={errors.email?.message || isError}
											value={formValues.email}
										/>
									</FormRow>
								</div>

								<Button
									onClick={handleSubmit(onSubmitHandler)}
									loading={isLoading}
									type="submit"
									size="xl"
									className={styles.login_recovery__form__btn}
								>
									{SEND_LINK_RECOVERY}
								</Button>
							</form>
						</FormProvider>

						<div className={styles.login_recovery__help}>
							<span>{PASSWORD_PROBLEM}</span>
							<span>
								{ADMINISTRATOR}{' '}
								<Link view="normal" href="mailto:edu@fond-igra.ru">
									{EMAIL}
								</Link>
							</span>
						</div>
					</>
				</div>
			)}

			{!isLoading && showMessage && <InfoMessage value={formValues.email} passRecovery />}
		</>
	);
};
